<div class="p-6 pb-3">

    <!-- Mobile tab selector and actions -->
    <div class="sm:hidden">
      <div class="mb-4">
        <select
          [(ngModel)]="activeFilter"
          (change)="setFilter(activeFilter)"
          aria-label="Filter leads"
          class="w-full rounded-md bg-white dark:bg-secondary-800 py-2 pr-8 pl-3 text-base text-gray-900 dark:text-white outline-1 -outline-offset-1 outline-gray-300 dark:outline-gray-600 focus:outline-2 focus:-outline-offset-2 focus:outline-primary">
          <option value="new">New</option>
          <option value="all">All</option>
          <option value="notifications">Notifications</option>
        </select>
      </div>
    </div>

    <!-- Desktop tabs and actions -->
    <div class="hidden sm:flex sm:items-center sm:justify-between">
      <!-- Tabs -->
      <nav aria-label="Lead filters" class="flex space-x-1">
        <a (click)="setFilter('new')"
           [class]="activeFilter === 'new' ? 'bg-violet-500/10 text-violet-600 dark:text-violet-400' : 'text-secondary dark:text-gray-400 hover:opacity-90'"
           class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition-colors">
          New
        </a>
        <a (click)="setFilter('all')"
           [class]="activeFilter === 'all' ? 'bg-violet-500/10 text-violet-600 dark:text-violet-400' : 'text-secondary dark:text-gray-400 hover:opacity-90'"
           class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition-colors">
          All
        </a>
        <a (click)="setFilter('notifications')"
           [class]="activeFilter === 'notifications' ? 'bg-violet-500/10 text-violet-600 dark:text-violet-400' : 'text-secondary dark:text-gray-400 hover:opacity-90'"
           class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition-colors inline-flex items-center gap-1.5">
          Notifications
          <span *ngIf="notificationsUnreadCount > 0"
                class="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[11px] font-medium leading-none bg-violet-500 text-white">
            {{ notificationsUnreadCount }}
          </span>
        </a>
      </nav>

      <!-- Right actions -->
      <div class="flex items-center gap-4 min-h-[36px]">
        <!-- Sort (leads tabs) -->
        <select
          *ngIf="activeFilter !== 'notifications'"
          [(ngModel)]="sortBy"
          (change)="onSortChange(sortBy)"
          class="rounded-md bg-white dark:bg-secondary-800 py-1.5 pr-8 pl-3 text-sm text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600 focus:outline-2 focus:-outline-offset-2 focus:outline-primary">
          <option value="newest">Newest first</option>
          <option value="oldest">Oldest first</option>
        </select>

        <!-- Get leads button (New & All tabs) -->
        <button
          *ngIf="activeFilter !== 'notifications'"
          type="button"
          (click)="onOpenIcpModal()"
          [disabled]="generating || runInProgress"
          class="btn btn-violet">
          <span *ngIf="!generating && !runInProgress">Get leads</span>
          <span *ngIf="generating || runInProgress" class="flex items-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Generating...
          </span>
        </button>

        <!-- Mark all read (notifications tab) -->
        <button
          *ngIf="activeFilter === 'notifications' && notificationsUnreadCount > 0"
          type="button"
          (click)="onMarkAllRead()"
          [disabled]="markingAllRead"
          class="inline-flex items-center gap-1.5 rounded-md border border-gray-200 dark:border-gray-600 bg-white dark:bg-secondary-800 px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-secondary-700 transition-colors disabled:opacity-40">
          <svg *ngIf="!markingAllRead" class="w-3.5 h-3.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
          </svg>
          <svg *ngIf="markingAllRead" class="animate-spin w-3.5 h-3.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Mark all read
        </button>
      </div>
    </div>

    <!-- Loading (content only) -->
    <div *ngIf="(loading || !runsChecked) && !runInProgress && activeFilter !== 'notifications'" class="flex justify-center items-center h-[calc(100vh-200px)]">
      <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <!-- Notifications -->
    <ng-container *ngIf="activeFilter === 'notifications'">

      <!-- Header bar (mobile mark all read) -->
      <div *ngIf="notificationsUnreadCount > 0" class="mt-5 flex items-center justify-end sm:hidden">
        <button
          type="button"
          (click)="onMarkAllRead()"
          [disabled]="markingAllRead"
          class="inline-flex items-center gap-1.5 rounded-md border border-gray-200 dark:border-gray-600 bg-white dark:bg-secondary-800 px-2.5 py-1 text-xs font-medium text-gray-700 dark:text-gray-300 disabled:opacity-40">
          Mark all read
        </button>
      </div>

      <!-- List -->
      <div *ngIf="notifications.length > 0" class="mt-6 rounded-lg border border-gray-200 dark:border-gray-700/60 divide-y divide-gray-100 dark:divide-gray-700/60 overflow-hidden">
        <div *ngFor="let notification of notifications"
             class="flex items-start gap-3 px-4 py-3 transition-colors"
             [class]="!notification.read_at
               ? 'bg-white dark:bg-secondary-800'
               : 'bg-gray-50/50 dark:bg-secondary-800/50'">

          <!-- Unread dot -->
          <span class="mt-1.5 shrink-0 w-1.5 h-1.5 rounded-full"
                [class]="!notification.read_at ? 'bg-violet-500' : 'bg-transparent'"></span>

          <!-- Body -->
          <div class="min-w-0 flex-1">
            <p class="text-[13px] leading-snug text-gray-900 dark:text-gray-100"
               [class.font-medium]="!notification.read_at">
              {{ notification.data.message }}
            </p>
            <p *ngIf="notification.data.suggestion"
               class="mt-0.5 text-[13px] leading-snug text-gray-500 dark:text-gray-400">
              {{ notification.data.suggestion }}
            </p>
          </div>

          <!-- Time -->
          <time class="shrink-0 text-[11px] text-gray-400 dark:text-gray-500 tabular-nums pt-0.5">
            {{ notification.created_at | date:'MMM d, h:mm a' }}
          </time>
        </div>
      </div>

      <!-- Empty -->
      <div *ngIf="notifications.length === 0" class="flex flex-col items-center justify-center h-[calc(100vh-280px)] text-center">
        <p class="text-sm text-gray-400 dark:text-gray-500">No unread notifications</p>
      </div>
    </ng-container>

    <!-- Cards grid -->
    <div *ngIf="!loading && activeFilter !== 'notifications' && filteredLeads.length > 0" class="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
      <app-lead-card-legacy
        *ngFor="let lead of filteredLeads; trackBy: trackByLeadId"
        [lead]="lead"
        [isGenerating]="generatingProfileId === lead.id"
        [hasReport]="generatedReports.has(lead.id)"
        (bookmarkToggle)="onBookmarkToggle($event)"
        (feedbackGiven)="onFeedbackGiven($event)"
        (viewProfile)="onViewProfile($event)"
        (sendEmail)="onSendEmail($event)"
        (viewDetails)="onViewDetails($event)">
      </app-lead-card-legacy>
    </div>

    <!-- Pagination -->
    <app-crm-pagination
      *ngIf="!loading && activeFilter !== 'notifications' && filteredLeads.length > 0 && meta && meta.total > 0 && meta.last_page > 1"
      [pagination]="meta"
      (pageChanged)="onPageChanged($event)"
      (perPageChanged)="onPerPageChanged($event)"
      class="mt-6 w-full">
    </app-crm-pagination>

    <!-- Empty state: Floating Avatar Constellation -->
    <div *ngIf="runsChecked && !loading && activeFilter !== 'notifications' && filteredLeads.length === 0" class="relative flex items-center justify-center h-[calc(100vh-280px)] overflow-hidden">

      <!-- Radial glow background -->
      <div class="constellation-glow absolute inset-0 pointer-events-none"></div>

      <!-- Orbit ring: avatars positioned on a perfect circle from center -->
      <div class="orbit-ring">
        <!-- 0° (top) - desktop only -->
        <div class="orbit-item orbit-0 hidden lg:block">
          <div class="animate-float-fast opacity-40" style="animation-delay: -1.5s;">
            <div class="w-7 h-7 rounded-full bg-violet-100 flex items-center justify-center p-2 shadow-lg">
              <div class="orbit-logo w-full h-full bg-violet-500"></div>
            </div>
          </div>
        </div>
        <!-- 45° (top-right) -->
        <div class="orbit-item orbit-1">
          <div class="animate-float-slow opacity-60" style="animation-delay: -3s;">
            <div class="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-violet-100 flex items-center justify-center p-2 shadow-lg">
              <div class="orbit-logo w-full h-full bg-violet-500"></div>
            </div>
          </div>
        </div>
        <!-- 90° (right) -->
        <div class="orbit-item orbit-2">
          <div class="animate-float opacity-50" style="animation-delay: -4s;">
            <div class="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-violet-100 flex items-center justify-center p-2 shadow-lg">
              <div class="orbit-logo w-full h-full bg-violet-500"></div>
            </div>
          </div>
        </div>
        <!-- 135° (bottom-right) -->
        <div class="orbit-item orbit-3">
          <div class="animate-float opacity-75" style="animation-delay: -2.5s;">
            <div class="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-violet-100 flex items-center justify-center p-2.5 shadow-lg">
              <div class="orbit-logo w-full h-full bg-violet-500"></div>
            </div>
          </div>
        </div>
        <!-- 180° (bottom) - desktop only -->
        <div class="orbit-item orbit-4 hidden lg:block">
          <div class="animate-float-slow opacity-45" style="animation-delay: -6s;">
            <div class="w-8 h-8 rounded-full bg-violet-100 flex items-center justify-center p-2 shadow-lg">
              <div class="orbit-logo w-full h-full bg-violet-500"></div>
            </div>
          </div>
        </div>
        <!-- 225° (bottom-left) -->
        <div class="orbit-item orbit-5">
          <div class="animate-float-slow opacity-70" style="animation-delay: -5s;">
            <div class="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-violet-100 flex items-center justify-center p-2.5 shadow-lg">
              <div class="orbit-logo w-full h-full bg-violet-500"></div>
            </div>
          </div>
        </div>
        <!-- 270° (left) -->
        <div class="orbit-item orbit-6">
          <div class="animate-float-fast opacity-80" style="animation-delay: -2s;">
            <div class="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-violet-100 flex items-center justify-center p-3 shadow-lg">
              <div class="orbit-logo w-full h-full bg-violet-500"></div>
            </div>
          </div>
        </div>
        <!-- 315° (top-left) -->
        <div class="orbit-item orbit-7">
          <div class="animate-float opacity-90" style="animation-delay: -1s;">
            <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-violet-100 flex items-center justify-center p-2.5 shadow-lg">
              <div class="orbit-logo w-full h-full bg-violet-500"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Center content -->
      <div class="relative z-10 flex flex-col items-center text-center px-4 max-w-md">

        <!-- People icon with pulse ring -->
        <div class="relative mb-6">
          <div class="pulse-ring absolute inset-0 rounded-full bg-violet-400/30"></div>
          <div class="relative w-16 h-16 rounded-full bg-violet-100 dark:bg-violet-500/20 flex items-center justify-center">
            <div class="orbit-logo w-8 h-8 bg-violet-500"></div>
          </div>
        </div>

        <!-- Branch 1: Not yet generated -->
        <ng-container *ngIf="!hasGenerated">
          <h3 class="text-lg font-semibold text-secondary dark:text-white">
            Discover your ideal prospects
          </h3>
          <p class="mt-2 text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
            AI-matched leads tailored to your ICP,<br>
            ready in seconds.
          </p>
          <button
            type="button"
            (click)="onOpenIcpModal()"
            [disabled]="generating || runInProgress"
            class="mt-6 btn btn-violet">
            <span *ngIf="!generating && !runInProgress">Get leads</span>
            <span *ngIf="generating || runInProgress" class="flex items-center">
              <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Generating...
            </span>
          </button>
        </ng-container>

        <!-- Branch 2: Generated with ICP adjustment notification -->
        <ng-container *ngIf="hasGenerated && icpAdjustmentNotification">
          <h3 class="text-lg font-semibold text-secondary dark:text-white">
            {{ icpAdjustmentNotification.data.message }}
          </h3>
          <p class="mt-2 text-sm text-violet-600 dark:text-violet-400 leading-relaxed">
            {{ icpAdjustmentNotification.data.suggestion }}
          </p>
          <div class="mt-6 flex items-center gap-3">
            <a
              [routerLink]="['/icp/edit', selectedIcpId]"
              class="btn btn-violet">
              Edit ICP
            </a>
            <button
              type="button"
              (click)="onRefreshLeads()"
              class="btn btn-blue">
              Refresh
            </button>
          </div>
        </ng-container>

        <!-- Branch 3: Generated successfully (or notification API failed) -->
        <ng-container *ngIf="hasGenerated && !icpAdjustmentNotification">
          <h3 class="text-lg font-semibold text-secondary dark:text-white">
            Leads generated successfully
          </h3>
          <p class="mt-2 text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
            Refresh to see your new leads.
          </p>
          <button
            type="button"
            (click)="onRefreshLeads()"
            class="mt-6 btn btn-violet">
            Refresh your page
          </button>
        </ng-container>
      </div>
    </div>

</div>

<!-- Select ICP Modal -->
<app-select-icp-modal-legacy
  *ngIf="showIcpModal"
  [icps]="icps"
  [loading]="icpsLoading"
  (closeModal)="onCloseIcpModal()"
  (confirm)="onGenerateLeads($event)">
</app-select-icp-modal-legacy>

<!-- Lead Detail Modal -->
<app-lead-detail-modal-legacy
  *ngIf="showDetailModal"
  [lead]="(selectedLead$ | async)"
  [loading]="(detailLoading$ | async) ?? false"
  (closeModal)="onCloseDetailModal()">
</app-lead-detail-modal-legacy>
